export const clearSessionStorageExcept = (keysToKeep: string[] = []) => {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const key = sessionStorage.key(i);
        if (key && !keysToKeep.includes(key)) {
            sessionStorage.removeItem(key);
        }
    }
};

export const clearLocalStorageExcept = (keysToKeep: string[] = []) => {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && !keysToKeep.includes(key)) {
            localStorage.removeItem(key);
        }
    }
};
